import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface WorkspacesState {
  currentWorkspaceId: string;
  workspaceCrops: unknown[];
}

const initialState: WorkspacesState = {
  currentWorkspaceId: '',
  workspaceCrops: [],
};

export const workspacesSlice = createSlice({
  name: 'workspaces',
  initialState,
  reducers: {
    setCurrentWorkspaceId: (state, { payload: { workspaceId } }: PayloadAction<{ workspaceId: string }>) => {
      state.currentWorkspaceId = workspaceId;
      return state;
    },
    setWorkspaceCrops: (state, { payload }: PayloadAction<unknown[]>) => {
      state.workspaceCrops = payload;
      return state;
    },
  },
  extraReducers: () => {
    // builder.addMatcher(workspacesApi.endpoints.);
  },
});

export const { setCurrentWorkspaceId, setWorkspaceCrops } = workspacesSlice.actions;
